var $body = $("body"),
  $doc = $(document),
  $html = $("html"),
  $win = $(window);
$(".popup-video")
  .off("click")
  .on("click", function (event) {
    if (!event.ctrlKey) {
      event.preventDefault();
      let video_src = $(this).attr("data-src"),
        modal = $("[data-popup-video]");
      const $content = `<div class="fluid-width-video-wrapper" style="padding-top: 56.25%">
                                     <iframe
                                            id="player"
                                            type="text/html"
                                            width="100%"
                                            frameborder="0"
                                            webkitAllowFullScreen
                                            mozallowfullscreen
                                            allowFullScreen
                                            src="https://www.youtube.com/embed/${video_src}?autoplay=1&mute=1">
                                        </iframe>
                                </div>`;
      modal.find(".halo-popup-content").html($content);
      $body.addClass("video-show");
    }
  });

$(
  "[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay"
).on("click", function (e) {
  let modalContent = $("[data-popup-video] .halo-popup-content");
  if (!modalContent.is(e.target) && !modalContent.has(e.target).length) {
    $body.removeClass("video-show");
    $("[data-popup-video] iframe").remove();
  }
});

$(".video-custom .tab")
  .off("click")
  .on("click", function (event) {
    const videoCustom = event.target.closest(".video-custom");
    const item = $(videoCustom).find(".halo-item");
    const tab = event.target.closest("li");
    const dataFilter = $(tab).data("filter");
    $(".video-custom .tabs .tab").each((index, element) => {
      element.classList.remove("is-active");
    });
    tab.classList.add("is-active");

    $(item).each((index, element) => {
      if (!$(item).hasClass("slick-slide")) {
        const value = $(element).data("filter");
        if (value != dataFilter && dataFilter != "all") {
          $(element).css("display", "none");
        } else {
          $(element).css("display", "block");
        }
      }
    });

    var videoCustomBlock = $("[data-video-custom-slide]");
    if (videoCustomBlock) {
      videoCustomBlock.slick("slickUnfilter");
      dataFilter != "all" &&
        videoCustomBlock
          .slick("slickFilter", `.${dataFilter}`)
          .slick("refresh");
    }
  });
